import {
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { ButtonComponent } from '../../../../components/feedback/button/button.component';
import { SectionComponent } from '../../../../components/layout/section/section.component';
import { FormArray, FormGroup } from '@angular/forms';
import { ICustomTileForm } from '../../../../entities/custom-tile.entity';
import { ICustomTileSectionForm } from '../../../../entities/custom-tile-section.entity';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { ERoute } from '../../../../constants/routes.enum';
import { CmsTextProviderService } from '../../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-start-page-card',
  templateUrl: './start-page-card-block.component.html',
  imports: [ButtonComponent, SectionComponent, LanguagePipe],
})
export class StartPageCardBlockComponent {
  public readonly id: InputSignal<string> = input.required();
  public readonly sectionForm: InputSignal<FormGroup<ICustomTileSectionForm>> =
    input.required();
  public readonly cardIndex: InputSignal<number> = input.required();
  public readonly sectionIndex: InputSignal<number> = input.required();
  public readonly card: InputSignal<FormGroup<ICustomTileForm>> =
    input.required();

  public readonly atDelete: OutputEmitterRef<FormGroup<ICustomTileForm>> =
    output<FormGroup<ICustomTileForm>>();

  public readonly router: Router = inject(Router);
  public readonly route: ActivatedRoute = inject(ActivatedRoute);

  protected readonly ERoute: typeof ERoute = ERoute;
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );

  deleteCard() {
    this.atDelete.emit(this.card());
  }

  deactivateDeleteCard(): boolean {
    return this.sectionIndex() === 0 && this.cardIndex() < 2;
  }

  public moveItemAtIndex(
    formArray: FormArray,
    index: number,
    newIndex: number
  ): void {
    const currentGroup = formArray.at(index);
    formArray.removeAt(index);
    formArray.insert(newIndex, currentGroup);
    formArray.updateValueAndValidity();

    this.sectionForm().markAsDirty();
  }
}
